/*
 * Import Libraries
 */

import React, { memo } from "react";
import { Layout, Modal } from "antd";
import _ from "lodash";
import {
  Redirect,
  Route,
  RouteComponentProps,
  StaticContext,
} from "react-router";
import { useSelector, useDispatch } from "react-redux";

/*
 * Import data
 */
import { setModal } from "features/modalSlice";
import SideBar from "components/Sidebar/Sidebar";
import AdminHeader from "components/Headers/AdminHeader";
import { closeModal } from "utils";
import route from "routes";

/*
 * function getRoute
 */
const getRoutes = (routes: any) => {
  return routes.map((prop: any, key: any) => {
    if (prop.collapse) {
      return getRoutes(prop.views);
    }
    if (prop.layout === "/admin") {
      return (
        <Route
          path={prop.layout + prop.path}
          component={prop.component}
          key={key}
        />
      );
    } else {
      return null;
    }
  });
};

/*
 * Layout Admin Pages
 */

const Admin: React.FC<
  RouteComponentProps<any, StaticContext, unknown>
> = () => {
  const dispatch = useDispatch();
  const modal = useSelector((state: any) => state.modalReducer);

  if (
    !localStorage.getItem("account") ||
    !localStorage.getItem("access-token") ||
    !localStorage.getItem("refresh-token")
  ) {
    localStorage.removeItem("access-token");
    localStorage.removeItem("refresh-token");
    localStorage.removeItem("account");
    return <Redirect to="/auth/login" />;
  }

  return (
    <Layout>
      <AdminHeader />
      <Layout hasSider={true}>
        <SideBar />
        <Modal
          centered
          afterClose={() => {
            closeModal(dispatch, setModal);
          }}
          key={"custom-modal"}
          open={_.get(modal, "open", false)}
          onCancel={() => {
            closeModal(dispatch, setModal);
          }}
          bodyStyle={{
            padding: 0,
          }}
          footer={false}
          title={_.get(modal, "title", "")}
          width={_.get(modal, "size", undefined)}
        >
          {_.get(modal, "content", "")}
        </Modal>
        {getRoutes(route.routesSM)}
      </Layout>
    </Layout>
  );
};

export default memo(Admin);
